// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAUOQLbtMTw_vd0MUUTpu5tN_mSY-0X8do",
  authDomain: "azdania-34424.firebaseapp.com",
  databaseURL: "https://azdania-34424-default-rtdb.firebaseio.com",
  projectId: "azdania-34424",
  storageBucket: "azdania-34424.firebasestorage.app",
  messagingSenderId: "166591271915",
  appId: "1:166591271915:web:5907d0b9c263d0c226bfae"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
